import { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { usePerformanceLogger } from '../hooks/usePerformanceLogger';

const PerformanceContext = createContext(null);

export function PerformanceContextProvider({ children }) {
  const { logViewComplete } = usePerformanceLogger();
  const location = useLocation();
  const [completed, setCompleted] = useState(false);
  const [startTime, setStartTime] = useState(null);
  const { cartItems } = useSelector((state) => state.cart);


  useEffect(() => {
    const pageStartTime = performance.now();
    setStartTime(pageStartTime);
    setCompleted(false);

  }, [location.pathname, cartItems?._id, logViewComplete]);

  const markComplete = useCallback(() => {
    if (!completed && startTime) {
      const path = location.pathname;
      const loadingTime = ((performance.now() - startTime) / 1000).toFixed(2);

      logViewComplete(cartItems?._id, path, {
        loadingTime: parseFloat(loadingTime),
        completionType: 'manual'
      });
      
      setCompleted(true);
    }
  }, [completed, startTime, logViewComplete, cartItems?._id, location.pathname]);

  return (
    <PerformanceContext.Provider value={{ markComplete }}>
      {children}
    </PerformanceContext.Provider>
  );
}

export function usePerformanceContext() {
  return useContext(PerformanceContext);
}